
import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

export default class extends Controller {
  static values = {
    accountId: String,
    dataSourceId: String,
    provider: String
  };

  change(event) {
    let selectedSchemaId = event.target.querySelector('option:checked').value;

    const uri = `/admin/accounts/${this.accountIdValue}/data_sources/schema_select`;
    const query = new URLSearchParams({
      data_source_id: this.dataSourceIdValue,
      source_type: this.providerValue,
      schema_id: selectedSchemaId,
    });

    // TOOD(meagar): Better way of building a URI?
    get(uri + '?' + query, { responseKind: 'turbo-stream' })
  }
}
